var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content questionnaire"},[_c('div',{staticClass:"fieldset"},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('IntroducerUsers')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }